module.exports = __webpack_public_path__ + "img/img_shiyanshi.b5ff31dc.jpg";